import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/characters", label: "角色图鉴" },
  { to: "/works", label: "作品库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200 text-foreground-950"
          : "bg-transparent border-b border-white/10 text-white"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <Link
          to="/"
          className="group flex items-center gap-2.5"
          aria-label="女神漫画角色图鉴 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-sparkling-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold tracking-wide">
            女神图鉴
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors hover:bg-white/10 md:hover:bg-primary-500/10 md:hover:text-primary-600"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/characters"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-all hover:bg-primary-600"
          >
            <i className="ri-compass-3-line text-base" aria-hidden="true"></i>
            探索图鉴
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-full border border-current/30"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <nav className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 text-sm font-medium text-foreground-950 hover:bg-background-100"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/characters"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 whitespace-nowrap"
            >
              <i className="ri-compass-3-line text-base" aria-hidden="true"></i>
              探索图鉴
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}